export default __webpack_public_path__ + "static/media/icon-agent-hands-up.d87a1012.svg";